module.exports = {"apiKey":"AIzaSyDU44CK70qFpvsxcahcnOZvQ6I_6q0VZbk","authDomain":"minigolflive.com","databaseURL":"https://wagm-prod.firebaseio.com","projectId":"wagm-prod","storageBucket":"wagm-prod.appspot.com","messagingSenderId":"923227362905","ga":"UA-118615348-1","RAVEN_DSN":"https://a407fbe1fe7f4789b261de536125290c@sentry.io/1201151"}


//////////////////
// WEBPACK FOOTER
// ./src/config/firebase/prod.json
// module id = 4603
// module chunks = 0